if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector || 
                                Element.prototype.webkitMatchesSelector;

if (!Element.prototype.closest)
    Element.prototype.closest = function(s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1); 
        return null;
    };


// fake cookies
// on load creat a cookie with name cookiesyes-consent
// value: consentid:R3hNYVhNS3V5N2FXZ0tWRnZncE9TZG45UTJpZmRlcHE,consent:no,action:,necessary:yes,functional:no,analytics:no,performance:no,advertisement:no,other:no

window.localStorage.setItem(
    'cookiesyes-consent', 
    'consentid:R3hNYVhNS3V5N2FXZ0tWRnZncE9TZG45UTJpZmRlcHE,consent:no,action:,necessary:yes,functional:no,analytics:no,performance:no,advertisement:yes,other:no'
);
